/*
 * Copyright (c) 2022 biocrates life sciences ag, All rights reserved.
 */

import ModuleSettings from "../../../@biocrates-common-repo/settings/models/moduleSettings"
import {TableSorting} from "../../../@biocrates-common-repo/core/models/tableSorting"
import {TableFiltering} from "../../../@biocrates-common-repo/core/models/tableFiltering"
import {ColumnWidth} from "../../../@biocrates-common-repo/core/models/columnWidth"
import {RefDbDataContext} from "../../../metstat/models/displayDataContext"

export interface GeneralSettings extends ModuleSettings {
    sorting: TableSorting[]
    filtering: TableFiltering[]
    columnWidths: ColumnWidth[]
    contextTemplates: ContextTemplate[]
}

export interface ContextTemplate {
    name: string
    context: RefDbDataContext
}

export interface State {
    general: GeneralSettings
}

export const initialState: State = {
    general: {
        initialized: false,
        sorting: undefined,
        filtering: undefined,
        columnWidths: undefined,
        contextTemplates: [],
    },
}
